import eq from 'lodash/eq'

import { EventBus } from '@/EventBus.js'
import DashboardWidget from './../../DashboardWidget'

const DEFAULT_PERIOD = 7 // 7 Days
const WIDGET_TIMEOUT = 1000 * 20 // 20 seconds

// @vue/component
export default {
  components: {
    DashboardWidget
  },

  props: {
    filter: {
      type: Object,
      default: () => ({
        organizationId:  null,
        projectId:       null,
        period:          null
      })
    }
  },

  data: () => ({
    error: undefined,
    eventBus: EventBus,
    isError: false,
    isLoading: true,
    period: DEFAULT_PERIOD,
    project: 'all',
    timeoutFn: null
  }),

  mounted () {
    this.eventBus.$on('widget-loaded', identifier => {
      // We timeout every request that takes longer than defined in "WIDGET_TIMEOUT".
      // We cancel this timeout if the widget is loaded before the amount of "WIDGET_TIMEOUT" has been reached
      if (eq(identifier, this.identifier)) {
        clearTimeout(this.timeoutFn)
      }
    })
  },

  watch: {
    isError () {
      // Always timeout on error case
      if (this.isError) {
        this.timeout()
      }
    },

    isLoading () {
      if (this.isLoading) {
        // Reset error state and hope this time it works
        this.setIsError(false)
        this.setError(undefined)

        // Start the timeout countdown
        this.timeoutFn = setTimeout(this.timeout, WIDGET_TIMEOUT)
      }
    },

    async filter() {
      await this.refresh();
    }
  },

  methods: {
    async refresh() {
    // Should be overriden in the parent widget components
    },

    setError (error) {
      this.error = error
    },

    setIsError (isError) {
      this.isError = isError
    },

    setIsLoading (isLoading) {
      this.isLoading = isLoading
    },

    // Handle timed out requests
    timeout () {
      this.setIsLoading(false)

      this.eventBus.$emit('widget-loaded', this.identifier)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/widgets/widgets/mixins/WidgetMixin.js